import React from 'react';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import Head from 'next/head';

import imageUrlBuilder from '@sanity/image-url';
import client from '../../../client';

const builder = imageUrlBuilder(client);

const ImagesCounter = styled('div')(({ theme }) => ({
  position: 'absolute',
  padding: `${theme.spacing(0.25)} ${theme.spacing(1)}`,
  background: `${theme.palette.common.black}d`,
  color: theme.palette.common.white,
  borderRadius: '4px',
  bottom: '15%',
  right: '25%',
  [theme.breakpoints.up('lg')]: {
    maxWidth: '1000px',
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '80%',
  },
}));

const ImageOverlayWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  maxWidth: '900px',
  [theme.breakpoints.up('lg')]: {
    maxWidth: '1000px',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
}));

function SlantPath(props) {
  return (
    <path
      d='M 2.57 16.6 L 858.57 16.6 C 880.661 16.6 894.093 34.509 888.57 56.6 L 752.82 599.6 C 747.297 621.691 724.911 639.6 702.82 639.6 L -153.18 639.6 C -175.272 639.6 -188.703 621.691 -183.18 599.6 L -47.43 56.6 C -41.907 34.509 -19.522 16.6 2.57 16.6 Z'
      {...props}
    />
  );
}

const StyledSlantPath = styled(SlantPath)(({ theme }) => ({
  fill: theme.palette.grey[200],
  transform: 'translate(2.5%, 5%)',
}));

function SingleSlantImage(props) {
  const {
    image,
    totalImageCount,
    aspectRatio = 2 / 3,
  } = props;

  const toHeight = (width) => Math.round(width * aspectRatio);
  const imgurl = builder.image(image).format('webp').width(950).height(toHeight(950))
    .url();
  return (
    <Grid item xs={12}>
      <Head>
        <link rel='preload' as='image' href={imgurl} />
      </Head>
      <ImageOverlayWrapper>
        {totalImageCount > 1 && (
          <ImagesCounter>1&ensp;/&ensp;{totalImageCount}</ImagesCounter>
        )}
        <svg viewBox='0 0 950 700' width='100%'>
          <StyledSlantPath />
          <defs>
            <clipPath id='galleryCoverSlanted'>
              <SlantPath fill='none' />
            </clipPath>
          </defs>
          <image
            href={imgurl}
            width='94%'
            height='93%'
            preserveAspectRatio='xMaxYMid slice'
            clipPath='url(#galleryCoverSlanted)'
            alt={(image || {}).alt}
          />
        </svg>
      </ImageOverlayWrapper>
    </Grid>
  );
}

export default SingleSlantImage;
